import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from '../../../tableSettings';
import {
  DateRenderer,DateTimeRenderer, FloatRenderer, TextAlignLeftWithAddressTooltipRenderer,
  NullableCheckboxIconRenderer, TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';
import AbstractListView, {
  DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer
} from "../../common/AbstractListView";
import {Search} from '../../../filtering';
import {airImportHawbList} from '../tableSettings';
import {JobNames} from '../../../framework.core/JobNames';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import {useHistory} from 'react-router';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import ApplicationContext from '../../../ApplicationContext';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import loadInfoAreaInvoiceBillCrDb from '../../../components/common/InfoAreaInvoiceBillCrDb';
import {AiHblListItem, AihListType} from '../../../fms.data/models/AiHblListItem';
import BlackInverseButton from "../../../ui/BlackInverseButton";
import IfmsModal from "../../../ui/IfmsModal";
import HawbMilestonePopup from "./HawbMilestonePopup";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import {ReactComponent as ContainerTrackingIcon} from "../../../img/container_tracking.svg";
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, RecognizedFilterRenderer, RecognizedRenderer, ShipmentTypeFilterRenderer, ShipmentTypeRenderer } from '../../common/commonListRenderers';
import * as XCol from '../../../framework.core/XExportColumn';
import useSetEditedId from '../../../hooks/useSetEditedId';
import { FmsSecTask } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask, findSecurityTaskWithBranch, getSecBySecTask } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import fastStorage from '../../../fastStorage';
import _ from 'lodash';
import RecogModal from '../../../ui/RecogModal';
import constants from '../../../constants';
import { formatShipmentType } from '../../common/utils/formatUtils';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BillingsIconButton, DeleteHistoryIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, RecogHistoryIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import { SecType } from '../../../fms.enum';
import JobSwitchingMenuContext from '../../jobSwitchingMenuContext';
import useJobMenus from '../../../hooks/useJobMenus';
import MultilineTextBox from '../../../ui/MultilineTextBox';
import SecondaryButton from '../../../ui/SecondaryButton';
import { SQLField, SQLInfo, SQLType } from '../../../framework.core/data/SQLInfo';
import { ApiResult, InsertResultsWithData } from '../../../framework.core/data/ApiResult';
import taskReminderIconRed from '../../../img/pin_red.svg';
import { AiHbl } from '../../../fms.core/AiHbl';

async function DoSave(rowId: number, PopupInputValue: string|null, appContext: any) {

  const sqlList: SQLInfo[] = [];


    sqlList.push(new SQLInfo({
      tableName: "T_AIHMAIN",
      type: SQLType.Update,
      fields:[
          new SQLField({fieldName: "F_IMemo", propertyName: "iMemo", value: PopupInputValue }),
      ],
     key: new SQLField({ fieldName: "F_Id", propertyName: "Id", value: rowId }),
    }));

  const apiResult: ApiResult<InsertResultsWithData> = await appContext.api.saveSQLInfoList(sqlList);

  const editModelKey = `editAiHawb${rowId}-/airImport/hawb/edit`;
  const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
  if (keyMatch) {
    fastStorage[keyMatch].iMemo = PopupInputValue;
  }
  
}

function useHawbOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  

  function switchToMawbFor(hawb: AiHblListItem | null) {
    if (!hawb) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/aiMawb/airImport', 
    'id', 'Ref. #', hawb.aiMblId, 'u2Date', false, true, null, 'refNo', hawb.refNo, false,true);
    openNewPage(history, `/common/joblistview/aiMawb/airImport`, NavigationType.newPage);
  }

  async function switchToAcctInfo(hbl:AiHblListItem|null) {
    if (!hbl) {
      return;
    }
    
    if (hbl.sbl) // Single BL
      openNewPage(history, `/accounting/Acct/${JobNames.AIMbl}/${hbl.aiMblId}`, NavigationType.newPage);
    else
      openNewPage(history, `/accounting/Acct/${JobNames.AIHbl}/${hbl.id}`, NavigationType.newPage);
  }


  async function RemarkColClickFor(row: any, data: any) {
    jobListContext.setRowExtrasId(data.id);
}

  return {switchToMawbFor, switchToAcctInfo, RemarkColClickFor};
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useHawbOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}


function RemarkRenderer({ row, cell }: any) {
  const { RemarkColClickFor } = useHawbOperations();

  return (
    <div
      onClick={() => RemarkColClickFor(row, row.original)}
      className="ifms-table-align-left"
    >
      {cell.value}&nbsp;
    </div>
  );
}



function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';
  else if (lStatus === 'AC') dataTooltip = 'Accounting Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  //}

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}


function MemoDetailRenderer({value, data, row}: any) {
  const {openDocServer} = useSelectedHawbOperation();

  const memoCnt = value;

  if(memoCnt === '0'){
    return <div className="ifms-table-default">{value}</div>;
  }

  return <div onClick={() => openDocServer(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em', cursor:'pointer'}}>{value}</div>
}

function RefNoRenderer({value, data, row, cell}: any){
    
  const isPending = data[row.index].taskPendingCnt > 0;

    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">
      {value}{isPending ? <img style={{marginBottom:'1px', marginLeft:'3px'}}width='11px' height='11px' src={taskReminderIconRed} />: <></>}
    </div>
}

function AgentRenderer({ cell, value, data, row }: any) {
  const agentCnt  = (data[row.index].agentCnt - 1);

  return ( 
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">{value}{agentCnt > 0 ? ' + ' + agentCnt : ''}</div>
  );
}

function useSelectedHawbOperation() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const { switchToMawbFor } = useHawbOperations();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();

  const selectedElement = jobListContext.selectedElement as AiHblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  const setSavedEntityAim = useSetEditedId([JobNames.AIMbl]);

  function openDocServer(hawb:AiHblListItem|null){
    if (!hawb) {
      return;
    }

    if(appContext.appInfoAreaContent === 'none') appContext.setAppInfoAreaContent('memo'); 
  }


  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/airImport/hawb/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const openedByF6 = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/common/joblistview/aiMawb/airImport';

    const openedByMaster = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/airImport/mawb/edit/' + jobListContext.f6Query;  

    const newUrl = openedByF6 || openedByMaster
      ? `/airImport/hawb/add?mawbRefId=${jobListContext.f6Query}`
      : '/airImport/hawb/add';

    openNewPage(history, newUrl, NavigationType.newPage);
  }

  async function deleteHbl() {
    if (!selectedElement) {
      return;
    }

    // if (
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/edit/${selectedElement.id}`) || 
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/view/${selectedElement.id}`)
    // ) {
    //   await showGlobalOkDialog('Need to close HAWB first', false, null, "warning");
    //   return;
    // }

    let id = selectedElement.id;
    let jobName = JobNames.AIHbl;
    let editUrl = `/airImport/hawb/edit/${id}`;
    let viewUrl = `/airImport/hawb/view/${id}`;

    if (selectedElement.sbl) {
      id = selectedElement.aiMblId;
      jobName = JobNames.AIMbl;
      editUrl = `/airImport/mawb/edit/${id}`;
      viewUrl = `/airImport/mawb/view/${id}`;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/${jobName}/${id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/${jobName}/${id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/${jobName}/${id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/${jobName}/${id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/${jobName}/${id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/${jobName}/${id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first.',false,null,'warning');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(jobName, { 
        id, 
        pimsLinkId: selectedElement.pimsLinkId, 
        sbl: selectedElement.sbl 
      });

      if (apiResult && apiResult.success) {
        // List에서 데이터를 Delete할 때 해당 데이터가 View/Edit 모드로 Open 되어있으면 그 탭을 Close하도록 동작
        // const editUrl = `/airImport/hawb/edit/${selectedElement.id}`;
        // const viewUrl = `/airImport/hawb/view/${selectedElement.id}`;
        if (jobListContext.hasOpenedScreenStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
            context.resetForCurrentJob();
            removeSingleJobMenuinTab(jobListContext.hasOpenedScreenStartingWithUrl(editUrl) ? editUrl : viewUrl, '');
        }
        jobListContext.reloadData();
        setSavedEntityAim(selectedElement.aiMblId?.toString(), false, true);
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');  
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    let id = selectedElement.id;
    let editUrl = `/airImport/hawb/edit/${id}`;
    let viewUrl = `/airImport/hawb/view/${id}`;

    if (selectedElement.sbl) {
      id = selectedElement.aiMblId;
      editUrl = `/airImport/mawb/edit/${id}`;
      viewUrl = `/airImport/mawb/view/${id}`;
    }

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/airImport/hawb/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    let id = selectedElement.id;
    let jobName = JobNames.AIHbl;
    const tabIndex = 2;
    let baseUrl = '/airImport/hawb';
    let editBaseUrl = `${baseUrl}/edit/${id}`;
    let viewBaseUrl = `${baseUrl}/view/${id}`;

    // Single BL
    if (selectedElement.sbl) {
      id = selectedElement.aiMblId;
      jobName = JobNames.AIMbl;
      baseUrl = '/airImport/mawb';
      editBaseUrl = `${baseUrl}/edit/${id}`;
      viewBaseUrl = `${baseUrl}/view/${id}`;
    } 

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);

    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${jobName}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  
  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewProfit() {
    if (!selectedElement) {
      return;
    }

    let id = selectedElement.id;
    let jobName = JobNames.AIHbl;
    let tabIndex = 4;
    let baseUrl = '/airImport/hawb';
    let editBaseUrl = `${baseUrl}/edit/${id}`;
    let viewBaseUrl = `${baseUrl}/view/${id}`;

    // Single BL
    if (selectedElement.sbl) {
      id = selectedElement.aiMblId;
      jobName = JobNames.AIMbl;
      tabIndex = 4;
      baseUrl = '/airImport/mawb';
      editBaseUrl = `${baseUrl}/edit/${id}`;
      viewBaseUrl = `${baseUrl}/view/${id}`;
    } 

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);
    
    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${jobName}TabIndexRequest${id}`] = tabIndex;
    }
    
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  async function moveToDeleteHistoryReport() {
    let id = selectedElement.id;
    let jobName = JobNames.AIHbl;

    // Single BL
    if (selectedElement.sbl) {
      id = selectedElement.aiMblId;
      jobName = JobNames.AIMbl;
    } 

    const listSec = findSecurityTask(appContext, FmsSecTask.AIDeleteHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    // if (!selectedElement) {
    //   return;
    // }

    const viewUrl = `/common/deleteHistory?jobname=${jobName}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToRecogHistoryReport() {
    let id = selectedElement.id;
    let jobName = JobNames.AIHbl;

    // Single BL
    if (selectedElement.sbl) {
      id = selectedElement.aiMblId;
      jobName = JobNames.AIMbl;
    } 

    const listSec = findSecurityTask(appContext, FmsSecTask.AIRecogHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    // if (!selectedElement) {
    //   return;
    // }

    const viewUrl = `/common/recogHistory?jobname=${jobName}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    let id = selectedElement.id;
    let editUrl = `/airImport/hawb/edit/${id}`;
    let viewUrl = `/airImport/hawb/view/${id}`;
    let listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AIHbl, selectedElement.branch);

    if (selectedElement.sbl) {
      id = selectedElement.aiMblId;
      editUrl = `/airImport/mawb/edit/${id}`;
      viewUrl = `/airImport/mawb/view/${id}`;
      listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AIMbl, selectedElement.branch);
    }

    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    let id = selectedElement.id;
    let copyUrl = '/airImport/hawb/add';

    if (selectedElement.sbl) {
      id = selectedElement.aiMblId;
      copyUrl = '/airImport/mawb/add';
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(copyUrl)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, `${copyUrl}?copyId=${id}`, NavigationType.newPage);
  }

  function switchToMawb() {
    const selectedElement = jobListContext.selectedElement as AiHblListItem;
    switchToMawbFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return { create, deleteHbl, edit, view, copy, switchToMawb, recognize, viewBillings, moveToDeleteHistoryReport, moveToRecogHistoryReport, viewProfit, setSavedEntityAim, openDocServer };
}

function HawbListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AiHblListItem;
  const history = useHistory();
  let listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AIHbl, selectedElement?.branch);

  const { copy, create, edit, view, switchToMawb, viewBillings, viewProfit } = useSelectedHawbOperation();
  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);
  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = !(fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = !(fmsGlobal.NoProfitShow ?? false);  
  const mawbSec = findSecurityTask(appContext, FmsSecTask.AIMbl);


  let id = selectedElement?.id??0;
  let jobName = JobNames.AIHbl;
  let infoHeadline = `HAWB #: ${selectedElement?.hawbNo ?? ''}`;

  if (selectedElement?.sbl) {
    id = selectedElement?.aiMblId??0;
    jobName = JobNames.AIMbl;
    listSec = findSecurityTask(appContext, FmsSecTask.AIMbl);
    infoHeadline = `HAWB #: ${selectedElement?.mawbNo ?? ''}`;
  }

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      if (mawbSec.grantRead)
        switchToMawb();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    }  else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F7") {
      if (noBillingsShow)
        viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      if (noProfitShow)
        viewProfit();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={jobName}
      jobId={id}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
      isDirectBl={false}    // List에 DBL은 표시하지 않도록 변경됨.
      isSingleBl={selectedElement?.sbl ?? false}
    />
  );
}

function HawbListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteHbl, edit, view, copy, switchToMawb, recognize, viewBillings, viewProfit } = useSelectedHawbOperation();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AiHblListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AIHbl, selectedElement?.branch);
  const mawbSec = findSecurityTask(appContext, FmsSecTask.AIMbl);

  const fmsGlobal = getFmsGlobal();
  const userID = appContext.user ? appContext.user.id ?? '' : '';
  const setSavedEntityAfterClose = useSetEditedId([JobNames.AIMbl]);

  function openBLStatus() {
    if (jobListContext.rowExtrasId) {
      jobListContext.setmodalShow("openBLStatus");
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(selectedElement.id);
    jobListContext.setmodalShow("openBLStatus");
  }

  async function processFileLock() {
    if (selectedElement.sbl) {
      processFileLockAsMawbFromHawb();
    } else {
      const fileLockResult = await appContext.api.opClose(JobNames.AIHbl, selectedElement.id, !(selectedElement as any).isClosed);
      if (!!fileLockResult) {
        await showGlobalOkDialog(fileLockResult,false,null,'warning');
        return;
      }

      const hasOpened =
      jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/view/${selectedElement.id}`)

      if (selectedElement.isClosed && hasOpened) {
        const editModelKey = `editAiHawb${selectedElement.id}-/airImport/hawb/edit`;
        const viewModelKey = `viewAiHawb${selectedElement.id}-/airImport/hawb/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
        if (keyMatch) {
          fastStorage[keyMatch].fileClosed = 0;
          fastStorage[keyMatch].isClosed = false;
          fastStorage[keyMatch].closedBy = '';
          fastStorage[keyMatch].closeDate = null;
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].fileClosed = 0;
          fastStorage[viewKeyMatch].isClosed = false;
          fastStorage[viewKeyMatch].closedBy = '';
          fastStorage[viewKeyMatch].closeDate = null;
        }
      }else  if (!selectedElement.isClosed && hasOpened) {
        const editModelKey = `editAiHawb${selectedElement.id}-/airImport/hawb/edit`;
        const viewModelKey = `viewAiHawb${selectedElement.id}-/airImport/hawb/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

        const closeDate = await appContext.api.getFieldValueDate({
          id: selectedElement.id,
          tableName: 'T_AIHMAIN',
          fieldName: 'F_CloseDate'
        });

        if (keyMatch) {
          fastStorage[keyMatch].fileClosed = 1;
          fastStorage[keyMatch].isClosed = true;
          fastStorage[keyMatch].closedBy = userID;
          fastStorage[keyMatch].closeDate = closeDate;
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].fileClosed = 1;
          fastStorage[viewKeyMatch].isClosed = true;
          fastStorage[viewKeyMatch].closedBy = userID;
          fastStorage[viewKeyMatch].closeDate = closeDate;
        }
      }

      jobListContext.reloadData();
    }
  }

  async function processFileLockAsMawbFromHawb() {
    if(!selectedElement) return;

    const mawbId = selectedElement.aiMblId;

    const fileLockResult = await appContext.api.opClose(JobNames.AIMbl, mawbId, !selectedElement.isClosed);
    
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult,false,null,'warning');
      return;
    }

    const hasOpened =
      jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/edit/${mawbId}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/view/${mawbId}`)
    
    if (selectedElement.isClosed && hasOpened) {
      const editModelKey = `editAiMawb${mawbId}-/airImport/mawb/edit`;
      const viewModelKey = `viewAiMawb${mawbId}-/airImport/mawb/view`;
      
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isFileClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;

        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.fileClosed = 0;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 0;
        fastStorage[viewKeyMatch].isFileClosed = false;
        fastStorage[viewKeyMatch].closedBy = '';
        fastStorage[viewKeyMatch].closeDate = null;

        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.fileClosed = 0;
          });
        }
      }
    } else if (!selectedElement.isClosed && hasOpened) {
      const editModelKey = `editAiMawb${mawbId}-/airImport/mawb/edit`;
      const viewModelKey = `viewAiMawb${mawbId}-/airImport/mawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

       const closeDate = await appContext.api.getFieldValueDate({
        id: mawbId,
        tableName: 'T_AIMMAIN',
        fieldName: 'F_CloseDate'
      });

      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 1;
        fastStorage[keyMatch].isClosed = true;
        fastStorage[keyMatch].closedBy = userID;
        fastStorage[keyMatch].closeDate = closeDate;
        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.fileClosed = 1;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 1;
        fastStorage[viewKeyMatch].isClosed = true;
        fastStorage[viewKeyMatch].closedBy = userID;
        fastStorage[viewKeyMatch].closeDate = closeDate;
        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.fileClosed = 1;
          });
        }
      }
    }

    setSavedEntityAfterClose('0', false, false, true);
    jobListContext.reloadData();
  }

  async function processAccountLock() {
    if (selectedElement.sbl) {
      processAccountLockAsMawbFromHawb();
    } else {
      const accountLockResult = await appContext.api.accountClose(JobNames.AIHbl, selectedElement.id, !(selectedElement as any).isAccountClosed);
      if (!!accountLockResult) {
        await showGlobalOkDialog(accountLockResult,false,null,'warning');
        return;
      }

      const hasOpened =
      jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/view/${selectedElement.id}`)

      if (selectedElement.isAccountClosed && hasOpened) {
        const editModelKey = `editAiHawb${selectedElement.id}-/airImport/hawb/edit`;
        const viewModelKey = `viewAiHawb${selectedElement.id}-/airImport/hawb/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

        if (keyMatch) {
          fastStorage[keyMatch].accountClosed = 0;
          fastStorage[keyMatch].isAccountClosed = false;
          fastStorage[keyMatch].accountClosedBy = '';
          fastStorage[keyMatch].accountCloseDate = null;
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].accountClosed = 0;
          fastStorage[viewKeyMatch].isAccountClosed = false;
          fastStorage[viewKeyMatch].accountClosedBy = '';
          fastStorage[viewKeyMatch].accountCloseDate = null;
        }
      } else if (!selectedElement.isAccountClosed && hasOpened) {
        const editModelKey = `editAiHawb${selectedElement.id}-/airImport/hawb/edit`;
        const viewModelKey = `viewAiHawb${selectedElement.id}-/airImport/hawb/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

        const accountCloseDate = await appContext.api.getFieldValueDate({
          id: selectedElement.id,
          tableName: 'T_AIHMAIN',
          fieldName: 'F_AcctCloseDate'
        });

        if (keyMatch) {
          fastStorage[keyMatch].accountClosed = 1;
          fastStorage[keyMatch].isAccountClosed = true;
          fastStorage[keyMatch].accountClosedBy = userID;
          fastStorage[keyMatch].accountCloseDate = accountCloseDate;
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].accountClosed = 1;
          fastStorage[viewKeyMatch].isAccountClosed = true;
          fastStorage[viewKeyMatch].accountClosedBy = userID;
          fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;
        }
      }

      jobListContext.reloadData();
    }
  }

  async function processAccountLockAsMawbFromHawb() {
    if(!selectedElement) return;

    const mawbId = selectedElement.aiMblId;

    const accountLockResult = await appContext.api.accountClose(JobNames.AIMbl, mawbId, !selectedElement.isAccountClosed);
    if (!!accountLockResult) {
      await showGlobalOkDialog(accountLockResult,false,null,'warning');
      return;
    }

    const hasOpened =
      jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/edit/${mawbId}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/view/${mawbId}`)

    if (selectedElement.isAccountClosed && hasOpened) {
      const editModelKey = `editAiMawb${mawbId}-/airImport/mawb/edit`;
      const viewModelKey = `viewAiMawb${mawbId}-/airImport/mawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 0;
        fastStorage[keyMatch].isAccountClosed = false;
        fastStorage[keyMatch].accountClosedBy = '';
        fastStorage[keyMatch].accountCloseDate = null;
        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.accountClosed = 0;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 0;
        fastStorage[viewKeyMatch].isAccountClosed = false;
        fastStorage[viewKeyMatch].accountClosedBy = '';
        fastStorage[viewKeyMatch].accountCloseDate = null;
        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.accountClosed = 0;
          });
        }
      }
    } else if (!selectedElement.isAccountClosed && hasOpened) {
      const editModelKey = `editAiMawb${mawbId}-/airImport/mawb/edit`;
      const viewModelKey = `viewAiMawb${mawbId}-/airImport/mawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

      const accountCloseDate = await appContext.api.getFieldValueDate({
        id: mawbId,
        tableName: 'T_AIMMAIN',
        fieldName: 'F_AcctCloseDate'
      });

      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 1;
        fastStorage[keyMatch].isAccountClosed = true;
        fastStorage[keyMatch].accountClosedBy = userID;
        fastStorage[keyMatch].accountCloseDate = accountCloseDate;
         if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.accountClosed = 1;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 1;
        fastStorage[viewKeyMatch].isAccountClosed = true;
        fastStorage[viewKeyMatch].accountClosedBy = userID;
        fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;
         if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.accountClosed = 1;
          });
        }
      }
    }

    setSavedEntityAfterClose('0', false, false, true);
    jobListContext.reloadData();
  }
  
  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock) && listSec?.grantEdit;
  let showAccountLock = (!selectedElement?.isAccountClosed ? getFmsGlobal().CanAccountLock : getFmsGlobal().CanAccountUnlock) && listSec?.grantEdit;
  // const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.confirmDate??'') < (getFmsGlobal().CloseDate??'');
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to MAWB List', shortcut: 'F6', separator: false, hidden : !mawbSec?.grantRead },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: noBillingsShow&&noProfitShow, hidden: !listSec?.grantAdd },
    { label: 'Billings', shortcut: 'F7', separator: noProfitShow, hidden: noBillingsShow },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: noProfitShow},
    { label: 'HAWB Status Update', shortcut: '', separator: false },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    { label: !selectedElement?.isAccountClosed ? 'Accounting Close' : 'Accounting Open', shortcut: '', separator: false, hidden: !showAccountLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize || !listSec?.grantEdit },
  ];

  const itemStatus = [
    { label: !selectedElement?.isClosed ? 'File Lock' : 'Unlock', shortcut: '', separator: false, hidden: !showFileLock },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="aih-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));
  
  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteHbl();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        switchToMawb();
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 7:
        copy();
        break;
      case 8:
        viewBillings();
        break;
      case 9:
        viewProfit();
        break;
      case 10:
        openBLStatus();
        break;
      case 11:
        processFileLock();
        break;
      case 12:
        processAccountLock();
        break;
      case 13:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  return null;
}

function HawbListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);

  const selectedElement = jobListContext.selectedElement as AiHblListItem;
  const setSavedEntityJournal = useSetEditedId([JobNames.SlipJournal]);

  const { deleteHbl, edit, view, copy, viewBillings, viewProfit, moveToDeleteHistoryReport, moveToRecogHistoryReport, setSavedEntityAim } = useSelectedHawbOperation();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const {switchJournal} = useJournal();
  
  // function hasOpenedViewOrEditFor(id:number) {
  //   return jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/view/${id}`);
  // }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/add`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityAim(selectedElement.aiMblId?.toString(), false);
    setSavedEntityJournal('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.AIHbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }

  function hasOpenedViewOrEditFor(id:number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/view/${id}`);
  }

  function switchJournalSBL(){
    return selectedElement.sbl ? switchJournal(JobNames.AIMbl, selectedElement.aiMblId, "", null, selectedElement.refNo) : switchJournal(JobNames.AIHbl, selectedElement.id, "", null, selectedElement.hawbNo)
  }

  const allowedStatuses = ['', 'E', 'D'];
  
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AIHbl, selectedElement?.branch);
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalOP, SecType.Read) && !userId.startsWith('@');


  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  
  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  

  const openedByF6 = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/common/joblistview/aiMawb/airImport';

  const openedByMaster = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/airImport/mawb/edit/' + jobListContext.f6Query;

  const newUrl = openedByF6 || openedByMaster
    ? `/airImport/hawb/add?mawbRefId=${jobListContext.f6Query}`
    : '/airImport/hawb/add';

  return (
    <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='aih-list-add-button' display="primary" link={newUrl} disabled={!canBeAdd} label={<FontAwesomeIcon icon={faPlus} />} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='aih-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
        <ViewIconButton2 name='aih-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
        <DeleteIconButton2 name='aih-list-delete-button' disabled={!canBeDeleted} onClick={deleteHbl} useText/>
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <PrimaryButton name='aih-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
        <BillingsIconButton name='aih-list-billings-button' onClick={viewBillings} useText/>
        {!noBillingsShow && <PrimaryButton name='aeh-list-profit-button' onClick={viewProfit} size="extrasmall" >Profit</PrimaryButton>}
        <DeleteHistoryIconButton name='aih-list-deleteHistory-button' onClick={moveToDeleteHistoryReport} useText/>
        <RecogHistoryIconButton name='aih-list-recogHistory-button' onClick={moveToRecogHistoryReport} useText/>
        {!checkSecJournal && <JournalIconButton onClick={() => switchJournalSBL()} useText/>}
      </div>
      {/* <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
         <ActionButton
          type="primary"
          // height="800px"
          variant="plain"
          onItemSelected={(event) => setSelectedPopupMenuItem(event)}
          items={[
            { label: 'Arrival Notice', separator: false, popupComponent: <HblArrivalNotice selectedElement={selectedElement} jobName={JobNames.AIHbl} />, popupLabel: 'Arrival Notice (HAWB)' },
            { label: 'Authority to Make Entry', separator: false, subMenu: FmsSubMenu.AuthEntry },
            { label: 'Correction Notice/Request', separator: false, popupComponent: <CorrectionNotice jobName={JobNames.AIHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Delivery Order (Pre Form)', separator: false, popupComponent: <DeliveryOrder jobName={JobNames.AIHbl} selectedElement={selectedElement} docType={DocumentType.DO} /> },
            { label: 'Delivery Order (Short Form)', separator: false, popupComponent: <DeliveryOrder jobName={JobNames.AIHbl} selectedElement={selectedElement} docType={DocumentType.DeliveryOrderShort} /> },
            { label: 'Pickup/Delivery Instruction', separator: true, popupComponent: <PickupDelivery jobName={JobNames.AIHbl} docType={DocumentType.Pickup} selectedElementId={selectedElement?.id} /> },
            { label: 'Est. Profit', separator: true, subMenu: FmsSubMenu.HouseProfit },
            { label: 'Cargo Status Query', separator: true, newCol: true, popupComponent: <CargoManifestStatus selectedElement={selectedElement} jobName={JobNames.AIHbl} /> },
            //{ label: 'Go to Carrier\'s Tracking', separator: true, newCol: true, link: 'http://dotnet.freightstream.com/fsutil/customs.asp?mbn=' + selectedElement?.mawbNo },
            { label: 'Carrier\'s Certificate', separator: false, subMenu: FmsSubMenu.CarrierCertificate },
            { label: 'Export Declaration for Transit', separator: false, subMenu: FmsSubMenu.ExdecTransit},
            { label: 'Print 7512', separator: false, popupComponent: <ItTeNotice jobName={JobNames.AIHbl} selectedElement={selectedElement} /> },
            { label: 'Memo List', separator: false, popupComponent: <MemoList selectedElement={selectedElement} jobName={JobNames.AIHbl} />, popupLabel: 'Memo List (HAWB)' },
            { label: 'Memo List (Customer)', separator: false, popupComponent: <MemoList selectedElement={selectedElement} jobName={JobNames.Company} />, popupLabel: 'Memo List (Customer)' },
            { label: 'Package Label', separator: false, popupComponent: <PackageLabel jobName={JobNames.AIHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Preliminary Claim Notice', separator: false, popupComponent: <PreliminaryClaimNotice jobName={JobNames.AIHbl} selectedElement={selectedElement} /> },
            { label: 'Proof of Delivery', separator: false, popupComponent: <ProofOfDelivery selectedElement={selectedElement} jobName={JobNames.AIHbl} />, popupWidth: 790 },
            { label: 'Release Order/Turnover', separator: false, popupComponent: <ReleaseOrderTurnover jobName={JobNames.AIHbl} selectedElementId={selectedElement?.id} />  },
            { label: 'Straight B/L', separator: true, popupComponent: <StraightBl jobName={JobNames.AIHbl} selectedElementId={selectedElement?.id} /> },

            // { label: 'Copy to CFS', separator: true },
          ]}
        >
          More Menu
        </ActionButton>
        &nbsp;
        <BlackInverseButton size='small' data-tooltip="Go to Carrier's Tracking"
          onClick={() => setSelectedPopupMenuItem({ label: 'Go to Carrier\'s Tracking', link: `http://dotnet.freightstream.com/fsutil/customs.asp?mbn=${selectedElement?.mawbNo}` })}>
          <img height="24px" width='24px' src={carriersTrackingIcon} alt="Go to Carrier's Tracking" style={{ position: 'relative', top: '-1px' }} />
        </BlackInverseButton>
      </div> */}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.aiMblId} mTbName={"T_AIMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function formatData(data:Array<AiHblListItem>) {
  return data.map(d => ({
    ...d,
  }));
}


function RemarkPopup({ rowId, onClose, cell, save }: { rowId: any, onClose: any, cell: any, save: any }) {
  const [remark, setRemark] = useState<string | null>(cell.value ?? '');
  const jobListContext = useContext(JobListViewContext);

  const infoHeadline = `Remark (Ref.# ${(jobListContext.selectedElement as AiHblListItem|null)?.refNo ?? ''})`;

  return (
    <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title={infoHeadline} width="550px">
      <div className='report-popup'>
        <div style={{ height: '200px', display: 'flex' }}>
          <div style={{ width: '480px' }}>
           <MultilineTextBox
                  name='aih-list-remark'
                  textId="remark"
                  style={{height: '190px'}}
                  value={remark}
                  onChange={e => setRemark(e.target.value)}
                  maxLength={800}
                />

          </div>
        </div>
        <div className="report-footer" >
          <SecondaryButton size="regular" focusable={true} onClick={() => { save(rowId, remark) }}>
            SAVE
          </SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton size="regular" focusable={true} onClick={onClose}>
            CANCEL
          </SecondaryButton>
        </div>
      </div>
    </IfmsModal>
  );
}


function AfterMemoLogButtonCommands() {
  return null;
}

/**
 * Concrete implementation for AI HAWB List screen
 *
 * @class HawbListView
 * @extends {AbstractListView}
 */
 class HawbListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings = airImportHawbList;
    const useBranch = systemSettings?.enableBranch ?? false;
    
    let cols: XCol.XExportColumn[] = [];
    if (this.systemSettings?.isCanada) {
      cols = AiHblListItem.getExportCollection(AihListType.NormalCan, useBranch);
    }
    else if (this.systemSettings?.showMilestoneInAihList) {
      cols = AiHblListItem.getExportCollection(AihListType.HblInfo, useBranch);
    }
    else {
      cols = AiHblListItem.getExportCollection(AihListType.Normal, useBranch);
    }

    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }
  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      // {
      //   accessor: 'recognized',
      //   renderer: RecognizedFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
    ];
  }
  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const lType = this.systemSettings?.showMilestoneInAihList ? AihListType.NormalCan : AihListType.Normal;
    const useBranch = systemSettings?.enableBranch ?? false;
    return AiHblListItem.getExportCollection(lType, useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if(x.dataIndex === "shipmentType") colRenderer.Cell = ShipmentTypeRenderer;
      // else if (x.dataIndex === 'recognized') {
      //     colRenderer.Cell = RecognizedRenderer;
      // }
      else if (x.dataIndex === "iMemo") {
        colRenderer.Cell = RemarkRenderer;
      }
      else if (x.dataIndex === 'memoCnt') colRenderer.Cell = MemoDetailRenderer;
      else if (x.dataIndex === 'refNo') colRenderer.Cell = RefNoRenderer;
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      else if (x.dataIndex === 'p') colRenderer.Cell = PaidRenderer;
      else if(x.dataIndex === 'agentName') colRenderer.Cell = AgentRenderer;
      else if (x.dataIndex === 'shipper' || x.dataIndex === 'consignee' || x.dataIndex === 'notify') colRenderer.Cell = TextAlignLeftWithAddressTooltipRenderer
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
   }

   getExportRenderers(): ExportRowRenderer[] {
     const colRenderer = [];
     colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
     colRenderer.push({ accessor: 'shipmentType', changedValue: (value: any) => { return formatShipmentType(value['shipmentType']) } });
     colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
     return colRenderer;
   }

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number, opType: string): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.AIHbl,
      'AiHblListItem',
      AiHblListItem.calculateSearchParameters(search, AiHblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

      if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
        return {data: [], totalCount: 0};
      }
  
      return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  
  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.AIHbl, 'AiHblListItem',
      AiHblListItem.calculateSearchParameters(search, AiHblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  formatData(apiResult.entities);
  }


  renderCommands(): React.ReactNode {
    return (
      <HawbListCommands />
    );
  }
  renderBeforeConfigureButton(): React.ReactNode {
    return (
      <HawbListToolbar />
    );
  }
  renderAfterConfigureButton(): React.ReactNode {
    return <></>
  }
  
  renderExtras(hideLogHistory: boolean): React.ReactNode {
    return <HawbListViewExtras hideLogHistory={hideLogHistory} />
  }
  public renderInsideTopRightOpMenu(): React.ReactNode {
    return (
      <BlackInverseButton size="large" data-tooltip="Container Tracking" >
        <ContainerTrackingIcon width={20} height={20} />
      </BlackInverseButton>
    );
  }
  getViewUrlFor(row: any): string {
    let id = row.id;
    let url = `/airImport/hawb/view/${id}`;

    if (row.sbl) {
      id = row.aiMblId;
      url = `/airImport/mawb/view/${id}`;
    }

    return row && id ? url : '';
  }
  getListViewTitle(): string {
    return 'HAWB List';
  }
  
  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.AIHbl} keyProp='id' showAdjustBalance={false} showFixJournal={false} />;
  }

  renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any,  appContext: any): React.ReactNode|null {
    if (!rowId) {
      return null;
    }
    const storageKey = `ai-hbl-milestone-${rowId}`;
    const storageStatusKey = `ai-hbl-status-milestone-${rowId}`;
    const selectedElement = context.selectedElement as AiHblListItem;

    function onClose() {
      // fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
      context.setmodalShow(undefined);
    }

    function save(rowId: number, PopupInputValue: string) {
       if (cell.value !== PopupInputValue) {
         DoSave(rowId, PopupInputValue, appContext);
         onClose();
         context.reloadData();
       }
       else
         onClose();
    }

    const aihSecurity = findSecurityTaskWithBranch(appContext, FmsSecTask.AIHbl, selectedElement?.branch);
    if (context.modalShow !== 'openBLStatus' && cell.column.dataIndex === 'iMemo' && aihSecurity?.grantEdit){
      return (
        <RemarkPopup rowId={rowId} onClose={onClose} save={save} cell={cell} />
      );
    } else if(context.modalShow == 'openBLStatus') {
         return (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title="HAWB Status Update" width="760px">
          <HawbMilestonePopup hawbId={rowId} statusStorageKey={storageStatusKey} storageKey={storageKey} onClose={onClose} isView={!aihSecurity?.grantEdit} />
        </IfmsModal>
      );
    }
     
   
  }
  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
  
  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  useLogHistory(): boolean {
    return true;
  }
}

export default HawbListView;
